<template>
  <div class="animated fadeIn setting-container step-container broadcast">
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">Broadcast</h4>
        <h6>broadcast SMS (มี {{$guser.user.clinic.sms_credit}} Credits)</h6>

        <div class="row">
          <div class="col-md-5 col-12">
            <div class="form-group">
              <select class="form-control" id="broadcastTypes" v-model="req.type">
                <option disabled value="">-- เลือกประเภท --</option>
                <option v-for="t in broadcastTypes" v-bind:value="t.name" v-bind:key="t.name">
                  {{ t.detail }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-5 form-inline" v-show="loading.checking && req.type!=='appointment_date'">
            <div class="form-group">
              <label><sync-loader size='10px'></sync-loader></label>
            </div>
          </div>
        </div>
        <div class="row" v-show="req.type==='appointment_date'">
          <div class="col-md-5 col-12">
            <multiselect id="selectedDoctor"
                        class="multi-select-form event-filt"
                        v-model="selectedDoctor" 
                        placeholder="Optional" 
                        :options="doctors" 
                        :multiple="false"
                        :hide-selected="true"
                        :allow-empty="true" 
                        @search-change="getDoctors"
                        selected-label="" 
                        select-label="" 
                        deselect-label=""
                        label="name" 
                        track-by="id"></multiselect>
          </div>
        </div>
        <div class="row" v-if="req.type==='appointment_date'">
          <div class="col-md-5 col-12">
            <div class="form-group">
              <flat-pickr 
                class="form-control" 
                v-model="req.date"
                placeholder="-- เลือกวันที่นัดหมาย --">
                </flat-pickr>
            </div>
          </div>
          <div class="col-md-5 form-inline" v-show="loading.checking">
            <div class="form-group">
              <label><sync-loader size='10px'></sync-loader></label>
            </div>
          </div>
        </div>

        <div class="row" v-if="req.type==='last_visit'">
          <div class="col-md-3 col-8">
            <div class="form-group">
              <select class="form-control" id="broadcastTypes" v-model="selectedMonth">
                <option disabled value="">-- เดือน --</option>
                <option v-for="m in months" v-bind:value="m.number" v-bind:key="m.number">
                  {{ m.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2 col-4">
            <div class="form-group">
              <select class="form-control" id="broadcastTypes" v-model="selectedYear">
                <option disabled value="">-- ปี --</option>
                <option v-for="y in years" v-bind:value="y" v-bind:key="y">
                  {{ y }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <select class="form-control" id="service" v-model="selectedServiceId">
                <option value="0">บริการทั้งหมด</option>
                <option v-for="s in services" v-bind:value="s.id" v-bind:key="s.id">
                  {{ s.th.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
          
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <textarea v-model="req.content" class="form-control" rows="3" placeholder="ข้อความใน SMS" maxlength="335"></textarea>
              <p class="text-length">ความยาวข้อความ {{req.content ? req.content.length : 0}} / {{67*5}}</p>
            </div>
          </div>
        </div>

        <div class="row" v-if="req.type==='appointment_date'">
          <div class="col-12">
            <h6>มี {{numberOfMessage}} นัดหมาย (ใช้ credit={{creditUsage}})</h6>
            <p>หมายเหตุ: ทุกๆข้อความยาว 67 ตัวอักษรใช้ 1 credit</p>
          </div>
        </div>
        <div class="row" v-if="req.type==='all_patients'">
          <div class="col-12">
            <h6>มีคนไข้ {{numberOfMessage}} คน (ใช้ credit={{creditUsage}})</h6>
            <p>หมายเหตุ: ทุกๆข้อความยาว 67 ตัวอักษรใช้ 1 credit</p>
          </div>
        </div>
        <div class="row" v-if="req.type==='last_visit'">
          <div class="col-12">
            <h6>มีคนไข้ {{numberOfMessage}} คน (ใช้ credit={{creditUsage}})</h6>
            <p>หมายเหตุ: ทุกๆข้อความยาว 67 ตัวอักษรใช้ 1 credit</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-lg btn-success" @click="sendMessage" :disabled="!isAbleToSend">Send</button>
          </div>
        </div>

        <div class="loader" v-show="loading.sending">
          <sync-loader size='10px'></sync-loader>
        </div>
      </div>
    </div>
    <sweet-modal icon="success" ref="success">Success!</sweet-modal>
    <sweet-modal icon="error" ref="fail">Fail: {{errorMessage}}</sweet-modal>
  </div>
</template>

<script>
import FlatPickr from 'vue-flatpickr-component'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import { SweetModal } from 'sweet-modal-vue'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  components: {
    FlatPickr,
    SyncLoader,
    SweetModal,
    Multiselect
  },
  props: {},
  data () {
    return {
      services: [],
      broadcastTypes: [
        {
          name: 'appointment_date',
          detail: 'เลือกตามวันที่นัดหมาย'
        },
        {
          name: 'all_patients',
          detail: 'เลือกคนไข้ทั้งหมด'
        },
        {
          name: 'last_visit',
          detail: 'เลือกตาม Last visit'
        }
      ],
      req: {
        type: '',
        date: null,
        content: null,
        date_from: null,
        start: null,
        end: null,
        service_id: null
      },
      selectedServiceId: 0,
      selectedMonth: '',
      selectedYear: '',
      selectedDoctor: {
        id: 0,
        name: 'แพทย์ทั้งหมด'
      },
      doctors: [],
      numberOfMessage: 0,
      errorMessage: null,
      loading: {
        checking: false,
        sending: false
      }
    }
  },
  computed: {
    isAbleToSend () {
      if (this.req.type === 'all_patients' &&
      this.numberOfMessage > 0 &&
      this.req.content &&
      this.req.content.length > 0) {
        return true
      } else if (this.req.type === 'appointment_date' &&
      this.numberOfMessage > 0 &&
      this.req.date &&
      this.req.content &&
      this.req.content.length > 0) {
        return true
      } else if (this.req.type === 'last_visit' &&
      this.numberOfMessage > 0 &&
      this.selectedMonth > 0 &&
      this.selectedYear > 0 &&
      this.req.content &&
      this.req.content.length > 0) {
        return true
      }
      return false
    },
    creditUsage () {
      let content = this.req.content ? this.req.content : ' '
      return this.numberOfMessage * Math.ceil(content.length / 67)
    },
    years () {
      let years = []
      let date = moment()
      for (let i = 0; i < 10; i++) {
        years.push(date.format('YYYY'))
        date.subtract(1, 'year')
      }
      return years
    },
    months () {
      return [
        { name: 'มกราคม', number: '01' },
        { name: 'กุมภาพันธ์', number: '02' },
        { name: 'มีนาคม', number: '03' },
        { name: 'เมษายน', number: '04' },
        { name: 'พฤษภาคม', number: '05' },
        { name: 'มิถุนายน', number: '06' },
        { name: 'กรกฎาคม', number: '07' },
        { name: 'สิงหาคม', number: '08' },
        { name: 'กันยายน', number: '09' },
        { name: 'ตุลาคม', number: '10' },
        { name: 'พฤศจิกายน', number: '11' },
        { name: 'ธันวาคม', number: '12' }
      ]
    }
  },
  watch: {
    'req.date' (date) {
      this.checkNumberOfMessage(date)
    },
    'selectedDoctor' (doctor) {
      this.req.doctor_id = (doctor && doctor.id !== 0 ? doctor.id : undefined)
      if (this.req.date) {
        this.checkNumberOfMessage(this.req.date)
      }
    },
    'req.type' (type) {
      if (type === 'all_patients') {
        this.checkNumberOfMessage(this.req.date)
      } else if (type === 'last_visit') {
        this.numberOfMessage = 0
        this.selectedServiceId = 0
      }
    },
    'selectedMonth' (selectedMonth) {
      if (this.selectedYear && selectedMonth) {
        this.req = this.sanitizeReq(this.req)
        this.checkNumberOfMessage(this.req.date)
      }
    },
    'selectedYear' (selectedYear) {
      if (selectedYear && this.selectedMonth) {
        this.req = this.sanitizeReq(this.req)
        this.checkNumberOfMessage(this.req.date)
      }
    },
    'selectedServiceId' (selectedServiceId) {
      if (this.selectedYear && this.selectedMonth && selectedServiceId) {
        this.req = this.sanitizeReq(this.req)
        this.checkNumberOfMessage(this.req.date)
      }
    }
  },
  methods: {
    async checkNumberOfMessage (date) {
      try {
        this.loading.checking = true
        let res = await this.$http.get(this.$APP_CONFIG.api.admin.broadcast_check(), { params: {
          type: this.req.type,
          date: date,
          start: this.req.start,
          end: this.req.end,
          doctor_id: this.req.doctor_id,
          service_id: this.req.service_id,
          clinic_id: this.$route.query.ref_clinic_id ? this.$route.query.ref_clinic_id : this.$guser.user.clinic.id
        }})
        this.numberOfMessage = res.body.numberOfMessage
        this.loading.checking = false
      } catch (e) {
        this.loading.checking = false
      }
    },
    async sendMessage () {
      try {
        // Process and sanitize request
        this.req = this.sanitizeReq(this.req)

        this.loading.sending = true
        await this.$http.post(this.$APP_CONFIG.api.admin.broadcast(), {
          type: this.req.type,
          date: this.req.date,
          start: this.req.start,
          end: this.req.end,
          doctor_id: this.req.doctor_id,
          content: this.req.content,
          service_id: this.req.service_id,
          clinic_id: this.$route.query.ref_clinic_id ? this.$route.query.ref_clinic_id : this.$guser.user.clinic.id
        })
        this.loading.sending = false
        this.$refs.success.open()
      } catch (res) {
        this.loading.sending = false
        this.errorMessage = res.body.error
        this.$refs.fail.open()
      }
    },
    getDoctors () {
      var self = this
      var params = {
        clinic_id: this.$guser.user.clinic.id
      }

      this.$http.get(self.$APP_CONFIG.api.admin.doctors(), {
        params: params,
        credentials: true
      }).then(resp => {
        this.doctors = resp.body.data
        this.doctors.unshift({
          id: 0,
          name: 'เลือกแพทย์ทั้งหมด'
        })
      })
    },
    async getServices () {
      this.services = (await this.$http.get(this.$APP_CONFIG.api.admin.clinicme_services(this.$route, this.$guser))).body.data
    },
    sanitizeReq (req) {
      if (req.type === 'last_visit') {
        req.start = moment(this.selectedYear + '-' + this.selectedMonth + '-01').format('YYYY-MM-DD')
        req.end = moment(this.selectedYear + '-' + this.selectedMonth + '-01').endOf('month').format('YYYY-MM-DD')
        req.service_id = parseInt(this.selectedServiceId) === 0 ? null : parseInt(this.selectedServiceId)
        req.date = null
      }
      return req
    }
  },
  created () {
    this.getDoctors()
    this.getServices()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "../../assets/base_container";
.broadcast {
  .loader {
    position: absolute;
    background: rgba(255,255,255,0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .v-spinner {
      position: absolute;
      top: 45%;
      left: 45%;
    }
  }
  .text-length {
    color: #808080;
  }
}
</style>



// WEBPACK FOOTER //
// Broadcast.vue?6c78ed49